import { Button } from 'reactstrap';
import React, { useState } from 'react';
import { DeactivateUserModal } from '../DeactivateUserModal';

interface PropTypes {
  userId: number;
}

export default function DeactivateUserButton(props: PropTypes) {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  return (
    <>
      <Button size='md' color='danger' onClick={() => setIsOpen(true)}>
        Deactivate User
      </Button>
      <DeactivateUserModal
        OnClose={() => setIsOpen(false)}
        isOpen={isOpen}
        userId={props.userId}
      />
    </>
  );
}
